import { DOMTextElement } from "./DOMTextElement";
import { TextManager } from "./TextManager";

export class DOMTextManager extends TextManager {

    constructor(private textLayer: HTMLDivElement) {
        super();
    }

    public createTextElement(text: string, lifetime?: number) : DOMTextElement {
        let element = new DOMTextElement(this);
        element.text = text;

        this.addText(element, lifetime);

        return element;
    }

    public addText(element: DOMTextElement, lifetime?: number) {
        super.addText(element, lifetime);
        this.textLayer.append(element.element);
    }
}
